(function ($, Drupal, once, drupalSettings) {
  Drupal.behaviors.nodeAdjudicator = {
    attach: function (context, settings) {
      once('nodeAdjudicator', '.node--type-adjudicator', context).forEach(function (block) {
        const tooltips = document.querySelectorAll('.has-tip');

        tooltips.forEach(tooltip => {
          const button = tooltip.querySelector('.tip');
          const content = tooltip.querySelector('.description').textContent;
          tippy(button, {
            content: content,
            theme: 'tomato',
          });
        });
      });
    }
  }
})(jQuery, Drupal, once, drupalSettings);


